// extracted by mini-css-extract-plugin
export default {"wrapper":"AppName_wrapper__JIn52","appLogo":"AppName_appLogo__y7HAA","withName":"AppName_withName__NbCmM","appName":"AppName_appName__42PuM"};